import isSiteExternal from "./isSiteExternal";
/**
 * Selects module based on the isExternal check.
 * @param externalModule
 * @param internalModule
 * @returns
 */ function externalModulePicker(externalModule, internalModule) {
    if (isSiteExternal()) {
        return externalModule;
    }
    return internalModule;
}
export default externalModulePicker;

//# sourceMappingURL=externalModulePicker.js.map